export const createProduct = /* GraphQL */ `
  mutation CreateProduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      id
      storeID
      createdAt
      updatedAt
      status
      name
      slug
      price
      body
      tags
      medias {
        type
        key
        bucket
        name
        extension
        size
      }
    }
  }
`;

export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      id
      storeID
      createdAt
      updatedAt
      status
      name
      slug
      price
      body
      tags
      medias {
        type
        key
        bucket
        name
        extension
        size
      }
    }
  }
`;

export const createProspect = /* GraphQL */ `
  mutation CreateProspect($input: CreateProspectInput!) {
    createProspect(input: $input) {
      email
      createdAt
      status
    }
  }
`;

export const updateProspect = /* GraphQL */ `
  mutation UpdateProspect($input: UpdateProspectInput!) {
    updateProspect(input: $input) {
      email
      updatedAt
      status
    }
  }
`;

export const updateStore = /* GraphQL */ `
  mutation UpdateStore($input: UpdateStoreInput!) {
    updateStore(input: $input) {
      id
      createdAt
      status
      slug
      hostname
      code
      name
      body
      logo {
        type
        key
        bucket
        name
      }
      tags
    }
  }
`;

export const createCart = /* GraphQL */ `
  mutation CreateCart($input: CreateCartInput!) {
    createCart(input: $input) {
      id
      createdAt
      updatedAt
      status
      storeID
      clientID
      client {
        firstname
        lastname
      }
      orderNumber
      delivery {
        type
        details
      }
      payment {
        type
        details
      }
      ticket
      items
      transactionID
    }
  }
`;

export const updateCart = /* GraphQL */ `
  mutation UpdateCart($input: UpdateCartInput!) {
    updateCart(input: $input) {
      id
      createdAt
      updatedAt
      status
      storeID
      clientID
      client {
        firstname
        lastname
      }
      orderNumber
      delivery {
        type
        details
      }
      payment {
        type
        details
      }
      ticket
      items
      transactionID
    }
  }
`;

export const createFAQ = /* GraphQL */ `
  mutation CreateFAQ($input: CreateFAQInput!) {
    createFAQ(input: $input) {
      id
      storeID
      productID
      question
      answer
    }
  }
`;

export const updateFAQ = /* GraphQL */ `
  mutation UpdateFAQ($input: UpdateFAQInput!) {
    updateFAQ(input: $input) {
      id
      storeID
      productID
      question
      answer
    }
  }
`;
